import qs from 'qs'

import { buildGetQuery } from '../../util'
import config from '../../config'
import { SearchReportType } from '../../components/report-modal/search-report-type'

type Params = {
  airportId: number
}

type QueryObject = {
  isPreview?: boolean
  entityState: string
  startedAtBegin?: string
  startedAtEnd?: string
  endedAtBegin?: string
  endedAtEnd?: string
  workOrderIds?: number[]
  workOrderTypeIds?: number[]
  facilityIds?: number[]
  conditionIds?: number[]
  locationIds?: number[]
  statusIds?: number[]
  priorityIds?: number[]
  notificationGroupIds?: number[]
  inspectionSubtypeIds?: number[]
  assignedToIds?: string[]
  searchText?: string
  searchIds?: number[]
  limit: number
  page: number
  sortBy?: string
  sortOrder?: string
  searchReportType?: SearchReportType
}

const getWorkOrdersReportRequest = (params: Params, queryObject: QueryObject | undefined): any => {
  const { airportId } = params

  const { isPreview, searchReportType, ...data } = queryObject || {}

  const queryString = qs.stringify({ preview: isPreview, searchReportType }, { addQueryPrefix: true })

  return {
    method: 'post',
    responseType: isPreview ? 'text/html' : 'blob',
    url: `${config.baseUrl}/${airportId}/WorkOrders/RenderReport${queryString}`,
    data: data,
  }
}

const useWorkOrdersReportQuery = buildGetQuery<Params, QueryObject | undefined, Blob | string | undefined>({
  getRequest: getWorkOrdersReportRequest,
  getQueryKey: (params, queryObject) => [
    'work-orders-report',
    params.airportId,
    queryObject?.isPreview,
    queryObject?.entityState,
    queryObject?.startedAtBegin,
    queryObject?.startedAtEnd,
    queryObject?.endedAtBegin,
    queryObject?.endedAtEnd,
    queryObject?.workOrderIds,
    queryObject?.workOrderTypeIds,
    queryObject?.facilityIds,
    queryObject?.conditionIds,
    queryObject?.locationIds,
    queryObject?.statusIds,
    queryObject?.priorityIds,
    queryObject?.notificationGroupIds,
    queryObject?.assignedToIds,
    queryObject?.searchText,
    queryObject?.searchIds,
    queryObject?.limit,
    queryObject?.page,
    queryObject?.sortBy,
    queryObject?.sortOrder,
    queryObject?.searchReportType,
    queryObject?.inspectionSubtypeIds,
  ],
  defaultOptions: {
    retry: false,
  },
})

export default useWorkOrdersReportQuery
